import { render, staticRenderFns } from "./Empty.vue?vue&type=template&id=522b603b&scoped=true"
var script = {}
import style0 from "./Empty.vue?vue&type=style&index=0&id=522b603b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522b603b",
  null
  
)

export default component.exports